import React, { useState } from "react"
import { injectIntl } from "react-intl"
import { makeStyles } from "@material-ui/styles"

// import { Hidden, ClickAwayListener } from "@material-ui/core"
// import { Navbar, MobileNavbar, CartModal, AddedToCartBanner } from ".."

import warningImg from "./warning-icon.jpg"

const useStyles = makeStyles(theme => ({
  root: {
    top: 0,
    fontSize: "16px",
    fontFamily:"Proxima Nova,Roboto,Helvetica,Arial,sans-serif",
    textAlign: "center",
    backgroundColor: "#fff8d9",
    marginTop: "0px",
  },
 
  banner:{
 display: "block",
  padding: "0px 0px 22px 37.5px",
  marginTop:"0px"
  },
  imgcovid:{

    position: "relative",
    height:"30px",
    width:"30px", 
    marginTop: "12px",
  }
}))

export default injectIntl(props => {
  // const [open, setOpen] = useState(true)
  // const [cartOpen, setCartOpen] = useState(false)
  // const [mainMenuValue, mainMenuSetValue] = useState()
  const { intl } = props

 
  // Items of the menu (menuItems object)

  const i18nmessages = intl.messages

  const classes = useStyles()
  return (
    <div className={classes.root}>
    <img className={classes.imgcovid} src={warningImg}  />
    {/* <span class="td-icon td-icon-warning" ></span> */}
      <p className={classes.banner}>{i18nmessages.covidBanner}</p>

     
    </div>
  )
})
